import { Component, OnInit, Input } from '@angular/core';
import { DeligateService } from '../deligate.service';
import { Observable } from 'rxjs/Observable';
import { Daterangepicker, DaterangepickerConfig, DaterangePickerComponent } from 'ng2-daterangepicker';
import { MatSnackBar } from '@angular/material';
import { SessionStorage } from 'ngx-webstorage';
import { Delegate, EditDelegate } from './deligate';
import { Router } from '@angular/router';
import { DeligateComponent } from '../deligate.component';
@Component({
  selector: 'app-add-deligate',
  templateUrl: './add-deligate.component.html',
  styleUrls: ['./add-deligate.component.css']
})
export class AddDeligateComponent implements OnInit {
  @SessionStorage() public user;
  @Input() public data;
  public role: string = 'EMP';
  public empName: string = '';
  public selectedempno: string = '';
  public selectedempname: string = '';
  public rmCode: string = '';
  public empListarray: any = [];
  public filteredOptions: Observable<string[]>;
  public daterange: any = {};
  public todaydate: any = new Date();
  public deligate: any = new Delegate();
  // public data: any;
  public options: any;
  constructor(
    public deligateService: DeligateService,
    private daterangepickerOptions: DaterangepickerConfig,
    public snackBar: MatSnackBar,
    public router: Router,
    public deligateComponent: DeligateComponent
  ) { }

  ngOnInit() {
    this.getempList(this.role);
    if (this.data.type == 'edit') {
      this.options = {
        locale: { format: 'DD/MM/YYYY' },
        alwaysShowCalendars: false,
        minDate: this.todaydate,
        opens: "right",
        autoApply: true,
        startDate: this.convertDate(this.data.data.delegatedFromDate), endDate: this.convertDate(this.data.data.delegatedToDate)
      };
      this.daterange.start = this.convertDate(this.data.data.delegatedFromDate);
      this.daterange.end = this.convertDate(this.data.data.delegatedToDate);

    } else {
      this.options = {
        locale: { format: 'DD/MM/YYYY' },
        alwaysShowCalendars: false,
        minDate: this.todaydate,
        opens: "right",
        autoApply: true
      };
    }
    // });
  }
  getempList(role) {
    this.empListarray = [];
    this.deligateService.getempList('rm').subscribe(
      (response) => {
        response.payload.forEach(value => {
          if (value.Empno !== this.user.Empno) {
            this.empListarray.push(value);
          }
          if (this.data.type == 'edit') {
            if (this.data.data.delegatedTo == value.Empno) {
              this.empName = value.Empname;
              this.selectedempno = value.Empno;
              this.rmCode = value.RMCode;
            }
          }
        });
      });
  }
  convertDate(date) {
    date = new Date(date); //Using this we can convert any date format to JS Date
    let mm = date.getMonth() + 1; // getMonth() is zero-based

    let dd = date.getDate();

    if (mm < 10) {
      mm = "0" + mm;
    }
    if (dd < 10) {
      dd = "0" + dd;
    }
    return [dd, mm, date.getFullYear()].join('/'); // padding
  }

  filterEntities(event: any) {
    const searchItem = event.target.value;
    if (event.target.value !== 'undefined') {
      this.filteredOptions = this.empListarray.filter(s => s.Empname.toLowerCase().indexOf(searchItem.toLowerCase()) == 0);
    }
  }
  rolechanged() {
    this.selectedempno = '';
    this.selectedempname = '';
    this.rmCode = '';
    this.empName = '';
    this.getempList(this.role);
  }
  // public options: any = {
  //   locale: { format: 'MM/DD/YYYY' },
  //   alwaysShowCalendars: false,
  //   minDate: this.todaydate,
  //   opens: "right",
  //   autoApply: true
  // };
  employeeSelected(option) {
    this.selectedempno = option.Empno;
    this.selectedempname = option.Empname;
    this.rmCode = option.RMCode;
  }
  public selectedDate(value: any) {
    this.daterange.start = value.start.format('YYYY-MM-DD');
    this.daterange.end = value.end.format('YYYY-MM-DD');
  }
  delegateButtonClicked() {
    let url;
    let updateDetail;
    if (this.selectedempno != '' && this.daterange && this.daterange.start != undefined &&
      this.daterange.start != '' && this.daterange.end != undefined && this.daterange.end != '') {

      let userObj = {
        "Empno": this.user.Empno,
        "Empname": this.user.Empname,
        "EmailID": this.user.EmailID,
        "Role": this.user.Role,
      };
      this.deligate.delegatedFrom = this.user.Empno;
      this.deligate.delegatedTo = this.selectedempno;
      this.deligate.delegatedToName = this.selectedempname;
      this.deligate.userObj = userObj;
      this.deligate.delegatedFromDate = this.daterange.start;
      this.deligate.delegatedToDate = this.daterange.end;
      if (this.data.type == "edit") {
        updateDetail = new EditDelegate({});
        url = 'updateDelegation';
        updateDetail.delegationID = this.data.data.delegationID;
        updateDetail.updateItems = this.deligate;
        this.deligate = updateDetail;
      }
      else {
        url = 'delegation/delegateEmployee';
      }
      this.deligateService.postDelegate(this.deligate, url).subscribe(
        (response) => {
          if (response.success) {
            this.snackBar.open('Delegated successfully', 'OK', {
              duration: 5000,
            });
            // this.router.navigate(['/rm/viewdelegate']);
            this.deligateComponent.editMode = false;
            this.deligateComponent.getDelegationList();
          } else {
            this.snackBar.open(response.payload.message, 'OK', {
              duration: 5000,
            });
          }
        });
    } else {
      this.snackBar.open('Please fill all the details', 'OK', {
        duration: 5000,
      });
    }

  }
  backToDelegate() {
    this.deligateComponent.editMode = false;
    this.deligateComponent.getDelegationList();
  }
}


// WEBPACK FOOTER //
// ./src/app/rm/deligate/add-deligate/add-deligate.component.ts